import { mapMap } from 'src/common/stores/adapters/bex-api/search/map-adapter';
import { mapPropertySearchResults, SearchMigrationAdapter } from 'stores/adapters';

import { HotelResultsViewModel } from 'models';

import { OperationResult, PropertyMapMigration } from '__generated__/api';

export const adaptMapAndProperties: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertyMapMigration.Query>
): HotelResultsViewModel => {
  const { data } = bexApiResults;
  const { propertySearch } = data;

  if (!propertySearch || !propertySearch.properties || !propertySearch.map) {
    return bffResults;
  }

  return {
    ...bffResults,
    hotels: mapPropertySearchResults(data),
    map: mapMap(data)
  };
};
